import { Else, If, Then } from 'react-if';
import { StoreGridProps } from '../../../../types/StoreTypes';
import Empty from '../../common/Empty';
import StoreGrid from './StoreGrid';
import S from './StoreList.module.scss';

/**
 * 에셋 리스트를 출력하는 그리드에 제목이 붙은 컴포넌트
 */
const StoreSaveList = (storeTitledListProps: StoreTitledListProps) => {
  const {
    listTitle,
    items,
    type
  } = storeTitledListProps;
  const filteredItems = items?.filter(value => value) ?? null;
  return <div className={S.main_wrapper} data-sentry-component="StoreSaveList" data-sentry-source-file="StoreSaveList.tsx">
      <div className={S.title_wrapper}>
        <h3 className={S.contents_title}>
          {listTitle}
          {` (${items.length})`}
        </h3>
      </div>
      <If condition={filteredItems?.length > 0} data-sentry-element="If" data-sentry-source-file="StoreSaveList.tsx">
        <Then data-sentry-element="Then" data-sentry-source-file="StoreSaveList.tsx">
          <StoreGrid items={filteredItems} type={type} data-sentry-element="StoreGrid" data-sentry-source-file="StoreSaveList.tsx" />
        </Then>
        <Else data-sentry-element="Else" data-sentry-source-file="StoreSaveList.tsx">
          <div className={S.empty_wrapper}>
            <Empty emptyItem={listTitle} data-sentry-element="Empty" data-sentry-source-file="StoreSaveList.tsx" />
          </div>
        </Else>
      </If>
    </div>;
};
export default StoreSaveList;
type StoreTitledListProps = StoreGridProps & {
  listTitle: string;
};